<template>
  <form>
    <div class="client-details-form-con">
      <div class="input-group">
        <div class="input-line">
          <label class="input-label">First name:</label>
          <input type="text" class="input-text" v-model="details.firstName" />
        </div>
        <div class="input-line">
          <label class="input-label">Last name:</label>
          <input type="text" class="input-text" v-model="details.lastName" />
        </div>
        <div class="input-line">
          <label class="input-label">Preferred name:</label>
          <input
            type="text"
            class="input-text"
            v-model="details.preferredName"
          />
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import QuestionMixin from './QuestionMixin';

export default {
  name: 'client-details',

  mixins: [QuestionMixin],

  data() {
    return {
      details: {
        firstName: '',
        lastName: '',
        preferredName: '',
      },
    };
  },

  watch: {
    details: {
      deep: true,
      handler(v) {
        this.setAnswer(v);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.client-details-form-con {
  margin: 15px 12.5%;
  width: 75%;
  height: 35vh;
  margin-top: -60px;
  padding-top: 10px;
  background-color: #e2f8fd;
  border-radius: 25px;
  box-shadow: 0 6px 12px rgba(#000, 0.16);

  .title-con {
    width: 58%;
    height: 20%;
    background-color: #b2e2f0;
    border-top-left-radius: 25px;
    border-bottom-right-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .title {
    margin-left: 25px;
    font-size: 24px;
    color: #1381a2;
  }
}
.input-group {
  margin-top: 42px;
  margin-left: 48px;
  .input-line {
    width: 56%;
    min-width: 230px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;

    .input-label {
      color: #1381a2;
      font-size: 20px;
    }
    .input-text {
      width: 300px;
      min-width: 100px;
      height: 47px;
      border: none;
      border-radius: 10px;
      font-size: 20px;
    }
    .input-text:focus {
      outline: none;
    }
  }
}

.btn-group {
  position: absolute;
  bottom: 17%;
  right: 13.7%;
  z-index: -1;
  .btn-clear {
    width: 120px;
    height: 55px;
    background-color: white;
    box-shadow: 0 6px 12px rgba(#000, 0.16);
    border: none;
    border-bottom-left-radius: 15px;
    color: #adadad;
    font-size: 18px;
    padding-top: 20px;
  }
  .btn-next {
    width: 120px;
    height: 30px;
    background-color: #3487a3;
    box-shadow: 0 6px 12px rgba(#000, 0.16);
    border: none;
    color: white;
    height: 55px;
    font-size: 18px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    margin-left: -15px;
    padding-top: 20px;
  }
}
</style>
